import React, { FC } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { GalleryVideoIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { LayoutBadge, ResponsiveSize } from '../PortfolioProjectCard/Layout';

export interface AttachmentsBadgeProps {
  totalCount?: number;
}

interface SizeProp {
  size: ResponsiveSize;
}

export const AttachmentsBadge: FC<AttachmentsBadgeProps & SizeProp> = ({ totalCount, size }) => {
  if (!totalCount || totalCount <= 0) {
    return null;
  }

  return (
    <LayoutBadge size={size}>
      <Stack gap="2" alignItems="center">
        <GalleryVideoIcon color="currentColor" />
        <Text color="inherit" size="b_sm" as="span">
          {totalCount}
        </Text>
      </Stack>
    </LayoutBadge>
  );
};
